import React from 'react'
import { Spinner } from 'reactstrap';

const LoadingScreen = () => {
    return <div className='fobk-loading'>
        <div className='fobk-loading__panel'>
            <Spinner color="primary" />
        </div>
    </div>
}

export default LoadingScreen;
